import { useEffect, useState } from 'react'

import { SupportHoursDTO } from 'models/conversations'

const MAX_TIMEOUT_MS = 2_147_483_647

export const useSupportHoursNow = (hours: SupportHoursDTO | undefined): number => {
  const nextOpeningAt = hours && !hours.openNow ? Date.parse(hours.nextOpeningAt) : NaN
  const hoursKey = hours ? `${hours.openNow}|${hours.nextOpeningAt}` : ''
  const [snapshot, setSnapshot] = useState(() => ({ hoursKey, now: Date.now() }))

  if (snapshot.hoursKey !== hoursKey) setSnapshot({ hoursKey, now: Date.now() })

  useEffect(() => {
    const delay = nextOpeningAt - Date.now()
    if (Number.isNaN(delay) || delay < 0) return
    const timer = window.setTimeout(
      () => setSnapshot((current) => ({ ...current, now: Date.now() })),
      Math.min(delay + 1, MAX_TIMEOUT_MS)
    )
    return () => window.clearTimeout(timer)
  }, [nextOpeningAt])

  return snapshot.hoursKey === hoursKey ? snapshot.now : Date.now()
}
